module.exports = __webpack_public_path__ + "01_glasses_red.44f00241.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer4/01_glasses_red.png
// module id = R8H2
// module chunks = 0